<div class="bg" animate.enter="entering">
  <div class="home-container">
    <div class="headline">
      <div class="text_container">
        <img class="logo"
          src="../../../assets/projects/schneidereipd/Logo.png"
        />
        <h1 class="header">I made something for you Granny!</h1>
      </div>
    </div>
    <div class="content">
      <app-content-card>
        <app-back-button [color]="Color"></app-back-button>
        <app-postcard class="accent"></app-postcard>
        <app-about-schneiderei class="accent"></app-about-schneiderei>
        <h2 class="accent">tags.</h2>
        <app-chip [chips]="chips" class="accent bg"></app-chip>
        <app-links
          class="accent"
          Instagram="{{ Instagram }}"
          Web="{{ Web }}"
        ></app-links>
        <app-footer class="accent"></app-footer>
      </app-content-card>
    </div>
  </div>
</div>
